module.exports = __webpack_public_path__ + "files/a4b4dac4e90a2ccfa336b7fc20971d22.png";